import { Dumbbell, History, PersonStanding, Scale } from 'lucide-react'

import type { SwipeTabSpec } from '@/components/shared/swipe-tabs'

export type WorkoutTab = 'today' | 'muscles' | 'history' | 'body'

/** 並びがスワイプの順番になる */
export const WORKOUT_TABS = [
  { value: 'today', label: '今日', icon: Dumbbell },
  { value: 'muscles', label: '部位', icon: PersonStanding },
  { value: 'history', label: '履歴', icon: History },
  { value: 'body', label: '体組成', icon: Scale },
] as const satisfies readonly SwipeTabSpec<WorkoutTab>[]

/** URL の ?tab= に使う値。知らない値は useQueryTabState が「今日」に戻す */
export const WORKOUT_TAB_VALUES: readonly WorkoutTab[] = WORKOUT_TABS.map((t) => t.value)
